import { useTranslation } from 'react-i18next'
import { LearningPathCardSmall } from 'components/ui/LearningPathCard'

import { LearningPathStatus } from 'enum/learningPathStatus.enum'
import { LearningPathEnrollStatus } from 'enum/learningPathEnrollStatus.enum'
import { usePrerequisites } from '../../../contexts/Prerequisites'
import styles from './style.module.scss'

export const LearningPathPrerequisites = () => {
  const { t } = useTranslation()
  const prefix = 'courses.show.content.prerequisites.byPrograms'

  const { learningPaths } = usePrerequisites()

  const prerequisites = learningPaths?.flatMap((item) => item.prerequisites)

  if (!prerequisites || prerequisites.length === 0) return null

  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>{t(`${prefix}.title`)}</div>
      <div className={styles.content}>{t(`${prefix}.description`)}</div>
      {prerequisites?.map(
        ({ id, name, description, pictureUrl, enrol, state }, index) => (
          <LearningPathCardSmall
            key={index}
            learningPath={{
              id: id,
              name: name,
              description: description,
              pictureUrl: pictureUrl,
            }}
            enrolStatus={enrol?.status ?? LearningPathEnrollStatus.pending}
            noAvailable={state === LearningPathStatus.draft}
            progress={enrol?.overallProgress || 0}
          />
        )
      )}
    </div>
  )
}
